import { render, staticRenderFns } from "./InsuranceDetailsAndVerificationNEW.vue?vue&type=template&id=10e76b6c"
import script from "./InsuranceDetailsAndVerificationNEW.vue?vue&type=script&lang=js"
export * from "./InsuranceDetailsAndVerificationNEW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports